// extracted by mini-css-extract-plugin
export default {"tagline":"Tagline-module--tagline--4d45e","small":"Tagline-module--small--9316f"};